import { Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ISpeciesTable } from 'common/defines/analytic';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const CustomTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

interface TableSpeciesCountProps {
  tableData: ISpeciesTable[];
}

const TableSpeciesCount: FC<TableSpeciesCountProps> = ({ tableData }) => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <CustomTableCell align="center">{t('trans.species_id')}</CustomTableCell>
            <CustomTableCell align="center">{t('trans.plant_species')}</CustomTableCell>
            <CustomTableCell align="center">{t('trans.count')}</CustomTableCell>
            <CustomTableCell align="center">{t('trans.percentage')}</CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row) => (
            <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell align="center">{row.speciesId}</TableCell>
              <TableCell align="center">{row.name}</TableCell>
              <TableCell align="center">{row.count}</TableCell>
              <TableCell align="center">{row.percentage.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSpeciesCount;
